module.exports = __webpack_public_path__ + "img/mobile.3a733c84.gif";